import React, { Component, createRef } from 'react';
// Composants
import { Menu, Item, Submenu } from 'react-contexify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// Librairies
import { connect } from 'react-redux';
import { faCheck } from '@fortawesome/pro-solid-svg-icons';
// Styles
import 'react-contexify/dist/ReactContexify.css';

class ContextMenu extends Component {
    constructor(props) {
        super(props);
        this.menuRef = createRef();
    }

    render() {
        const { id, isDarkTheme, onVisibilityChange, items } = this.props;

        return (
            <Menu
                id={id} ref={this.menuRef} theme={isDarkTheme ? 'dark' : 'light'} animation={false}
                style={{ maxHeight: '70vh', borderRadius: 'var(--radius-sm)', overflowY: 'auto', zIndex: 99999 }}
                onVisibilityChange={onVisibilityChange}
            >
                {this.renderItems(items)}
            </Menu>
        );
    }

    renderItems = (items) => {
        if (!items?.length) return null;
        return items.map((item, id) => {
            // Séparateurs
            if (item.isDivider)
                return (
                    <hr key={id} style={{ border: 'none', borderTop: '1px solid var(--grey-200, rgba(255, 255, 255, 0.1))', margin: '4px 0' }} />
                );

            // Éléments et sous-menus
            if (!item.isVisible || item.isVisible())
                return item.children
                    ? <Submenu key={id} label={item.label} disabled={item.isDisabled}>{this.renderItems(item.children)}</Submenu>
                    :
                    <Item key={id} onClick={item.onClick} disabled={item.isDisabled}>
                        <div className={item.className} style={{ display: 'flex', alignItems: 'center', marginRight: '10px' }}>
                            {item.icon && <FontAwesomeIcon icon={item.icon} style={{ marginRight: '10px', width: '15px' }} />}
                            <span className={item.className || ''}>{item.label}</span>
                            {item.isChecked && item.isChecked() && <FontAwesomeIcon icon={faCheck} style={{ marginLeft: '10px' }} />}
                        </div>
                        {item.shortcut && <div style={{ marginLeft: 'auto', color: 'var(--grey-100)' }}>{item.shortcut}</div>}
                    </Item>;
            else return null;
        });
    }
}

const mapStateToProps = (state) => {
    return {
        isDarkTheme: state.isDarkTheme
    };
}

export default connect(mapStateToProps)(ContextMenu);